import React from 'react'
import { Col, Container, Row } from 'reactstrap'

import Navbar from '../pages/Navbar/index/Index'
import PlanSidebar from '../pages/Plans/sidebar/PlanSidebar'

const PlanLayout = ({ children, isCustomProfile }) => (
    <React.Fragment>
        <Container fluid>
            <Row>
                <Col sm="3" className="vh-100 p-0" style={{ zIndex: 1 }}>
                    <PlanSidebar isCustomProfile={isCustomProfile} />
                </Col>
                <Col sm="9" className="p-0">
                    <Navbar isPlan />
                    {children}
                </Col>
            </Row>
        </Container>
    </React.Fragment>
)

export default PlanLayout
